import React from "react";

import ClassDataImg from "../../../assets/svg/class-data.svg";
import GroupClass from "../../../organisms/teacher/GroupClass";
import TeacherHeader from "../../../organisms/teacher/TeacherHeader";
import { IGrade } from "../../../pages/teacher/types";
import { IClass } from "../../../state";

import styles from "./ClassDataList.module.scss";

export type Props = {
  classes: IClass[];
};

const links = [{ name: "クラスデータ", to: "#" }];

const ClassDataList: React.FC<Props> = ({ classes }) => {
  const listClass = React.useMemo(() => {
    const grades: IGrade[] = [];
    classes.forEach(cls => {
      if (!grades.find(item => item.grade === cls.grade)) {
        grades.push({
          grade: cls.grade,
          classes: [
            {
              id: cls.id,
              name: cls.full_name,
              charged: cls.charged,
              assumed_entrance_year: cls.assumed_entrance_year,
            },
          ],
        });
      } else {
        const index = grades.findIndex(item => item.grade === cls.grade);
        grades[index].classes.push({
          id: cls.id,
          name: cls.full_name,
          charged: cls.charged,
          assumed_entrance_year: cls.assumed_entrance_year,
        });
      }
    });
    return grades;
  }, [classes]);

  return (
    <>
      <TeacherHeader links={links} />
      <div className={styles.wrapper}>
        <div className={styles.groupCheck}>
          <img src={ClassDataImg} alt="class-room" />
          <p>データを見たいクラスを選んでください</p>
        </div>
        <GroupClass listClass={listClass} forward forwardData />
      </div>
    </>
  );
};

export default ClassDataList;
